import * as React from "react";
import { Modal, Spin, notification } from "antd";
import { getAllCoin } from "../../Graphs/Master/Coin/listCoin";
import { RemoveUserCoinForm } from "./RemoveUserCoinForm";
import { removeUserCoin } from "../../Graphs/UserCoin/removeUserCoin";
import { alertError } from "../../utils/alert";

export class RemoveUserCoinModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      recordDetails: {},
      isLoading: false, // Fixme this should be true
      closable: true,
      coinsList: [],
    };
  }

  async componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }

    await this.getCoinsList();
  }

  addSubmit = async (value) => {
    try {
      this.setState({
        isLoading: true,
      });

      let createObject = value;
      createObject.user_id = this.props.userSelectedData.id;

      let coinData = await removeUserCoin(this.props.authToken, createObject);

      if (coinData.status == 200) {
        this.setState({
          isLoading: true,
        });

        notification["success"]({
          message: "Coin",
          description: "Successfully Debited",
        });
        return 1;
      } else {
        throw coinData && coinData.message ? coinData.message : "Error";
      }
    } catch (error) {
      this.setState({
        isLoading: false,
      });

      alertError("Coin", error);

      return -1;
    }
  };

  getCoinsList = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      let coinData = await getAllCoin(this.props.authToken, 0, 100000);
      this.setState({
        coinsList: coinData.data,
      });
    } catch (error) {
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState({
      visible: false,
    });
    this.props.onClose();
  }

  render() {
    return (
      // <StyleBox>
      <Modal
        width="600px"
        closable={this.state.closable}
        open={this.state.visible}
        title="Debit User Coin"
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        {this.state.isLoading ? (
          <div style={{ justifyContent: "center" }}>
            <Spin />
          </div>
        ) : (
          <RemoveUserCoinForm
            coinsData={this.state.coinsList}
            data={this.props.userSelectedData}
            onSubmit={this.addSubmit}
            handleCancel={this.handleCancel}
          />
        )}
      </Modal>
    );
  }
}
